import React, { FC, useCallback, SyntheticEvent } from 'react'

import * as SC from './styled'

export type DayButtonProps = React.ComponentPropsWithoutRef<'button'> & {
  className?: string
  date?: string
  textDesktop?: string
  textMobile?: string
  number?: string
  isActive?: boolean
  onClickFunction?: (date: string, ev: SyntheticEvent) => void
  showDate?: boolean
  isLongText?: boolean
}

const DayButton: FC<DayButtonProps> = (props) => {
  const {
    className,
    date,
    textDesktop,
    textMobile,
    number,
    isActive = false,
    showDate = true,
    onClickFunction,
    isLongText = false,
    ...rest
  } = props
  const onClickHandler = useCallback(
    (ev) => {
      onClickFunction?.(date ?? '', ev)
    },
    [onClickFunction, date]
  )
  return (
    <SC.Button
      className={className}
      isActive={isActive}
      onClick={onClickHandler}
      isLongText={isLongText}
      {...rest}
    >
      <SC.Inner>
        {textDesktop && <SC.TextDesktop>{textDesktop}</SC.TextDesktop>}
        {textMobile && <SC.TextMobile>{textMobile}</SC.TextMobile>}
        {number && showDate && <SC.Number>{number}</SC.Number>}
      </SC.Inner>
    </SC.Button>
  )
}

export default DayButton
